// import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';

export const CommonTnc = (): JSX.Element => {
  const { t, i18n } = useTranslation();
  const termsNConditionshref =
    i18n.language == 'en'
      ? 'https://www.generali.com.hk/EN_US/legal_information'
      : 'https://www.generali.com.hk/ZH_HK/legal_information';
  const privacyPolicyhref =
    i18n.language == 'en'
      ? 'https://www.generali.com.hk/EN_US/privacy_security_cookies'
      : 'https://www.generali.com.hk/ZH_HK/privacy_security_cookies';
  return (
    <Trans i18nKey="common.termNPolicy">
      {[
        // <Link key="termsNConditions" to="/terms-and-conditions" target="_blank" />,
        // <Link key="privacyPolicy" to="/privacy-policy" target="_blank" />,
        <a key="termsNConditions" href={termsNConditionshref} target="_blank" rel="noreferrer" />,
        <a key="privacyPolicy" href={privacyPolicyhref} target="_blank" rel="noreferrer" />,
        <a key="personalInfoCollectionDoc" href={t('settings.privacyPolicyLink')} target="_blank" rel="noreferrer" />,
      ]}
    </Trans>
  );
};
